// ABOUTME: Toast context definition and types
// ABOUTME: Separates context creation from provider component for React Fast Refresh compatibility

import { AlertColor } from "@mui/material";
import { createContext } from "react";

export interface Toast {
  id: string;
  message: string;
  severity: AlertColor;
  autoHideDuration?: number;
  action?: React.ReactNode;
}

export interface ToastContextType {
  showToast: (
    message: string,
    severity?: AlertColor,
    options?: Partial<Toast>,
  ) => void;
  showSuccess: (message: string, options?: Partial<Toast>) => void;
  showError: (message: string, options?: Partial<Toast>) => void;
  showWarning: (message: string, options?: Partial<Toast>) => void;
  showInfo: (message: string, options?: Partial<Toast>) => void;
  showPersistent: (
    message: string,
    severity?: AlertColor,
    action?: React.ReactNode,
  ) => string;
  dismissToast: (id: string) => void;
}

export const ToastContext = createContext<ToastContextType | undefined>(
  undefined,
);
